module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chapter_fm1",
    attrs: {
      "id": "c15"
    }
  }, [_c('span', {
    staticClass: "chapter_fm1"
  }, [_vm._v("c. 800")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter"
  }, [_vm._v("Viking Steel")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("There are a number of Viking swords that are head and shoulders above everything else that was available to the discriminating customer in the ninth century—in fact, no better steel was to be found in Europe until the Industrial Revolution. The Vikings may have come across superior ironworking technology in their trade with Asia, based on the wootz steels of India and Sri Lanka, whose furnaces took advantage of the monsoon winds. These blades had high carbon content, with far fewer impurities than the usual processes produced. The result was a metal alloy that remained at once tough, sharp, and flexible—a great advantage if you were trying to get one’s sword unstuck from an enemy’s shield, or perhaps from an enemy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These superior swords all bear the name "), _c('em', [_vm._v("Ulfberht")]), _vm._v(" on the lower part of the blade, indicating some sort of workshop, trade name, or Viking metalsmith. The earliest blades are attached to handles that have been carbon-dated to c. 800, and they were made for about two hundred years, with no examples dating later than about the year 1000. Like so many other technological advances for which we lack written records, the exact technique used to make them has been lost, although some educated guesses have produced similar alloys in experiments. As with modern techniques, attention to detail and quality control are critical. Metals can form a wide variety of crystalline structures while being forged, and control of these factors has never been easy to attain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ulfberht swords were clearly rare and highly prized, and the workshop that made them was paid a high compliment by the many other swords made from inferior steels but bearing variant spellings of the name. The inescapable conclusion is that these were copies, trading on the fame of the originals. Knockoffs have clearly been a problem for a long time.")]), _vm._v(" "), _c('p', {
    staticClass: "seealso"
  }, [_c('strong', [_vm._v("SEE ALSO")]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c04"
    }
  }, [_vm._v("Iron Smelting (c. 1300 BCE)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('div', {
    staticClass: "dis_img"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/043.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A Viking sword from Hedeby, which was an important trading settlement near the current German-Danish border.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-703cd0da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/c15.vue
// module id = 120
// module chunks = 0